export var patient = {
    900: '#1F256A',
    800: '#303077',
    700: '#3A367F',
    600: '#453E88',
    500: '#4D438E',
    400: '#675D97',
    300: '#8078A9',
    200: '#A39EC1',
    100: '#C7C4DA',
    50: '#E9E7F0',
};
//# sourceMappingURL=patient.js.map